import { jsPDF } from 'jspdf';

import 'fonts/PTSans-Regular-normal';

const PAGE_PORTRAIT_WIDTH = 253;
const PAGE_LANDSCAPE_WIDTH = 370;
const DEFAULT_COLUMN_WIDTH = .1;

const adjustWidths = (columnWidths, headers) => {
    const columnWidthsLength = columnWidths.length;
    columnWidths.length = headers.length;

    if (columnWidthsLength < headers.length) {
        columnWidths.fill(DEFAULT_COLUMN_WIDTH, columnWidthsLength);
    }

    const total = Object.entries(columnWidths).filter(([key, value]) => key in headers).map(([, value]) => value).reduce((a, b) => a + b, 0);

    const result = {...columnWidths};

    Object.keys(result).forEach(key => {
        result[key] = result[key] * (1 / total);
    });

    return result;
}

export const savePdfReport = ({ headers, items, columnWidths, autoSize, titleText, titleTextRight, fileTitle }) => {
    const adjustedWidths = columnWidths && adjustWidths(columnWidths, headers);
    const parsedHeaders = Object.entries(headers).map(([key, value]) => ({
        id: key,
        name: key,
        prompt: value,
        width: adjustedWidths && (adjustedWidths[key] * PAGE_LANDSCAPE_WIDTH),
        align: 'left',
        padding: 0
    }));

    const doc = new jsPDF({
        putOnlyUsedFonts: true,
        orientation: 'landscape',
    });

    doc.setFont('PTSans-Regular');

    items.forEach(row => {
        Object.entries(row).forEach(([key, val]) => {
            if (typeof val === 'number') {
                row[key] = val.toString();
            } else if (!val) {
                row[key] = ' ';
            }
        });
    });

    if (titleText) {
        doc.text(titleText, 10, 15);
    }

    if (titleTextRight) {
        doc.text(titleTextRight, 200, 15, null, null, 'right');
    }

    const tableTop = titleText || titleTextRight ? 20 : 10;
    doc.table(10, tableTop, items, parsedHeaders, {
        fontSize: 8,
        padding: 1.5,
        autoSize,
        font: 'PTSans-Regular'
    });

    doc.save((fileTitle || 'Nifty Report').trim() + '.pdf', {
        top: 32,
        bottom: 10,
        left: 10,
        width: 200
    });
}
